<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 NTC History 상세</h2>

      <h3 class="rew19_third_title">신청자 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>NTC 주문번호</em>
          <span class="substance">{{viewData.ntcNo}}</span>
        </li>
        <li class="type1">
          <em>신청자</em>
          <span class="substance">{{viewData.member_name}} ({{member_id}})</span>
        </li>
        <li class="type1">
          <em>카드번호</em>
          <span class="substance">{{viewData.print_ccard_no}}</span>
        </li>
        <li class="type1">
          <em>결제금액</em>
          <span class="substance">{{$fmt.WON(viewData.payment_amt)}} 원</span>
        </li>
        <li class="type1">
          <em>결제일</em>
          <span class="substance">{{viewData.regDate}}</span>
        </li>
        <li class="type1">
          <em>상태</em>
          <span class="substance">
            <span class="gep_btnRight">{{viewData.payProcessType}}</span>
            <a href="#" class="rew19_btn_border" v-if="viewData.payProdess_status == '2'">재결제</a>
          </span>
        </li>
      </ul>

      <h3 class="rew19_third_title">주문 상품</h3>
      <div class="rew19_payment_content" v-for="(item, idx) in viewData.pd_list" :key="idx">
        <div class="rew19_flex_box">
          <div class="rew19_payment_list__img">
            <img :src="item.pd_img_url1" alt title
                 onError="imageError(this)" data-error-cnt="0"
            />
          </div>

          <div class="rew19_payment_list__infor">
            <h4>{{item.pd_name_kr}}</h4>
            <ul class="rew19_payment_items">
              <li>
                <span class="rew19_point rew19_gDetail">{{$fmt.WON(item.pd_amt)}} 원 / {{item.pd_count}}개</span>
              </li>
              <li v-if="getMemberType() == 'DIST'">
                <span class="rew19_gDetail">
                  <em>NTC SV</em> {{$fmt.PV(item.pv)}}
                </span>
              </li>
              <li>
                <span class="rew19_gDetail">
                  <em>합계</em> {{$fmt.WON(item.total_amt)}} 원
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="rew19_payment_bottom">
        <ul class="rew19_payList">
          <li v-if="getMemberType() == 'DIST'">
            <em class="rew19_payTitle">합계 SV</em>
            <span class="rew19_payDetail">{{$fmt.PV(viewData.pv)}}</span>
          </li>
          <li v-bind:class="{lastLine : getMemberType() == 'DIST'}">
            <em class="rew19_payTitle">주문금액</em>
            <span class="rew19_payDetail rew19_point">
              <strong>{{$fmt.WON(viewData.payment_amt)}} 원</strong>
            </span>
          </li>
        </ul>
      </div>

      <div class="rew19_responsive_btns gepTaye1">
        <router-link :to="{name:'ntcHistoryList'}" class="rew19-btn-normal">목록</router-link>
      </div>
    </div>
    <!--rew19_contents_inner-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

import DF from 'dateformat';

export default {
  name: "ntcHistoryDetail",
  extends: AroBase,
  components: { },
  computed: {
     isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
     }
  },
  props:{
    ntc_no: {
      type: String,
      required: true
    },
    web_order: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      //View Data
      viewData : {},
      params : {
      },
      member_id : null,
      testText : ""
    };
  },
  created() {
  },
  mounted() {
    let _this = this;

    _this.loadData();
  },
  methods: {
    /**
     * JQuery UI
     */
    initUI(){

    },

    /**
     * API Request
     */
    // ntc history detail
    apiGetNtcHistoryDetail(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc_history_detail`, {
        params: {
          ntc_no : _this.ntc_no,
          web_order : _this.web_order
        }
      });
    },

    //ntc 철회하기
    apiCancelNtc(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/cancel_ntc`, {});
    },

    /**
     * Local function
     */
    //데이터 로드
    loadData(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetNtcHistoryDetail().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.viewData = {...res.data};
          _this.member_id = _this.getMemberId();

        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    // 철회하기
    onClickCancelNtc : function(ntc_no){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'확인'};
      _this.$dialogs.confirm("NTC " + ntc_no + " 정기기부를 철회하시겠습니까?", options).then(res=>{
        if(res.ok){
          _this.doCancelNtc();
        }
      });
    },

    // 철회하기
    doCancelNtc(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiCancelNtc().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("회원님의 정기기부가 철회되었습니다.", {okLabel:"확인"})
          .then(res => {});

        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },


  }
}
</script>
<style>
a.rew19-btn-normal, a.rew19_btn_T1, a.rew19_btn_border{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/ntc/historyDetail.vue